import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '@purespectrum1/ui/modal';

import { Constants } from '../../../shared/constants/create-survey.constants';
import {
  AdvanceTargetingQualification,
  Flexible,
  QuotaFlags,
  SelectedQuota,
} from '../../../shared/interfaces/qualification.interface';

import { QuotaModalService } from '../../quota-modal/quota-modal.service';

import { QuotaModalComponent } from '../../quota-modal/quota-modal.component';
import { ConfirmationModalComponent } from '../../../shared/ui/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'ps-ui-advance-targeting-quotas',
  templateUrl: './advance-targeting-quotas.component.html',
  styleUrls: ['./advance-targeting-quotas.component.css'],
})
export class AdvanceTargetingQuotasComponent implements OnInit {
  @Input() complete!: number;
  @Input() clickBalance!: number;
  @Input() flexible?: Flexible;
  @Input() quotas?: SelectedQuota[];
  @Input() qualification!: AdvanceTargetingQualification;
  @Input() isQlcLiveSurvey: boolean = false;
  @Input() hasNestedGroup: boolean = false;
  @Output() readonly quotaChanged = new EventEmitter();

  public quotaFlags: QuotaFlags = {
    add: true,
    edit: false,
    delete: false,
  };

  constructor(
    private _modal: ModalService,
    private _quotaModalService: QuotaModalService
  ) {}

  ngOnInit(): void {
    // set default flexibility in case of undefined.
    if (!this.flexible) {
      this.flexible = {
        enable: true,
        value: 0,
      };
    }
    if (this.quotas?.length) {
      this.quotaFlags = {
        add: false,
        edit: true,
        delete: true,
      };
    }
  }

  openQuotaModal(qualification: AdvanceTargetingQualification) {
    if (this._quotaModalService.inValidComplete(this.complete)) {
      return;
    }

    const modalRef = this._modal.open(QuotaModalComponent, {
      data: {
        quotas: this.quotas,
        complete: this.complete,
        flexible: this.flexible,
        clickBalance: this.clickBalance,
        isAdvancedTargeting: true,
        qualification: {
          ...qualification,
          data: qualification.selectedAnswers.map((answer) => {
            answer.selected = true;
            return answer;
          }),
          render_type: Constants.QUALIFICATIONS_RENDER_TYPE.MULTIPUNCH_DROPDOWN,
          is_location: false,
          is_range: false,
        },
        hasNestedGroup: this.hasNestedGroup,
      },
      width: '80%',
    });

    modalRef.onClose$.subscribe((response) => {
      if (
        [
          Constants.QUOTA_MODAL_ACTION.APPLY_QUOTA,
          Constants.QUOTA_MODAL_ACTION.APPLY_NEST_QUOTA,
        ].includes(response?.msg)
      ) {
        this.quotas = response.quotas;
        this.flexible = response.flexible;
        this.quotaFlags = {
          add: false,
          edit: true,
          delete: true,
        };
        this.quotaChanged.emit(response);
      }
    });
  }

  deleteQuotas(qualification: AdvanceTargetingQualification) {
    const modalRef = this._modal.open(ConfirmationModalComponent, {
      data: {
        text: Constants.CONFIRM_MODAL_TEXT.DELETE_QUOTA.replace(
          '<QUALIFICATION_NAME>',
          `${qualification.qualification_name}`
        ),
      },
    });

    modalRef.onClose$.subscribe((msg) => {
      if (msg === 'ok') {
        this.quotas = [];
        this.quotaFlags = {
          add: true,
          edit: false,
          delete: false,
        };

        this.quotaChanged.emit({
          msg: 'deleteQuota',
          qualification: this.qualification,
          quotas: this.quotas,
          flexible: this.flexible,
        });
      }
    });
  }
}
